import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";

// Material-UI Core
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

// Custom Component
import RFITransferList from "../../TransferList/RFITransferList";
import RFITransferGroupList from "../../TransferList/RFITransferGroupList";

// Custom Style
import { circulationRecipientFormStyle } from "../../../styles/jss/components/circulation/circulationRecipientFormStyle";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={1}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `submission-tab-${index}`,
    "aria-controls": `submission-tabpanel-${index}`,
  };
};

const useStyles = makeStyles((theme) => circulationRecipientFormStyle(theme));

const RFIRecipientForm = (props) => {
  const classes = useStyles();
  const {
    recipientType,
    userGroupType,
    internalOnly,

    getUserListLoading,
    getGroupListLoading,
    internalUserList,
    externalUserList,
    userGroupList,

    reciptentChipAdd,
    reciptentChipRemove,

    leftCcUserRcpt,
    setLeftCcUserRcpt,
    rightCcUserRcpt,
    setRightCcUserRcpt,

    leftCcGroupRcpt,
    setLeftCcGroupRcpt,
    rightCcGroupRcpt,
    setRightCcGroupRcpt,

    leftResponsibleUserRcpt,
    setLeftResponsibleUserRcpt,
    rightResponsibleUserRcpt,
    setRightResponsibleUserRcpt,

    leftResponsibleGroupRcpt,
    setLeftResponsibleGroupRcpt,
    rightResponsibleGroupRcpt,
    setRightResponsibleGroupRcpt,

    leftApproveUserRcpt,
    setLeftApproveUserRcpt,
    rightApproveUserRcpt,
    setRightApproveUserRcpt,

    leftApproveGroupRcpt,
    setLeftApproveGroupRcpt,
    rightApproveGroupRcpt,
    setRightApproveGroupRcpt,

    leftSecondApproveUserRcpt,
    setLeftSecondApproveUserRcpt,
    rightSecondApproveUserRcpt,
    setRightSecondApproveUserRcpt,

    leftSecondApproveGroupRcpt,
    setLeftSecondApproveGroupRcpt,
    rightSecondApproveGroupRcpt,
    setRightSecondApproveGroupRcpt,

    leftThirdApproveUserRcpt,
    setLeftThirdApproveUserRcpt,
    rightThirdApproveUserRcpt,
    setRightThirdApproveUserRcpt,

    leftThirdApproveGroupRcpt,
    setLeftThirdApproveGroupRcpt,
    rightThirdApproveGroupRcpt,
    setRightThirdApproveGroupRcpt,

    leftConsultantUserRcpt,
    setLeftConsultantUserRcpt,
    rightConsultantUserRcpt,
    setRightConsultantUserRcpt,

    leftConsultantGroupRcpt,
    setLeftConsultantGroupRcpt,
    rightConsultantGroupRcpt,
    setRightConsultantGroupRcpt,

    leftArchitectUserRcpt,
    setLeftArchitectUserRcpt,
    rightArchitectUserRcpt,
    setRightArchitectUserRcpt,

    leftArchitectGroupRcpt,
    setLeftArchitectGroupRcpt,
    rightArchitectGroupRcpt,
    setRightArchitectGroupRcpt,

    leftToUserRcpt,
    setLeftToUserRcpt,
    rightToUserRcpt,
    setRightToUserRcpt,

    leftToGroupRcpt,
    setLeftToGroupRcpt,
    rightToGroupRcpt,
    setRightToGroupRcpt,

    leftToExternalUserRcpt,
    setLeftToExternalUserRcpt,
    rightToExternalUserRcpt,
    setRightToExternalUserRcpt,

    leftToExternalGroupRcpt,
    setLeftToExternalGroupRcpt,
    rightToExternalGroupRcpt,
    setRightToExternalGroupRcpt,

    leftPMUserRcpt,
    setLeftPMUserRcpt,
    rightPMUserRcpt,
    setRightPMUserRcpt,

    leftPMGroupRcpt,
    setLeftPMGroupRcpt,
    rightPMGroupRcpt,
    setRightPMGroupRcpt,
  } = props;

  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  let idxCount = recipientType === "CC" ? 2 : 1;
  return (
    <Fragment>
      <div className={classes.root}>
        <AppBar position="static" color="default">
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="document submission tabs "
            textColor="primary"
            indicatorColor="primary"
          >
            {recipientType === "ARCHITECT" ||
            recipientType === "CONSULTANT" ||
            recipientType === "TOEXTERNAL" ? (
              <Tab key={0} label="External User" {...a11yProps(0)} />
            ) : (
              <Tab key={0} label="Internal User" {...a11yProps(0)} />
            )}
            {recipientType === "CC" && (
              <Tab key={1} label="External User" {...a11yProps(0)} />
            )}
            {userGroupType !== null
              ? userGroupType.map((res) => {
                  return (
                    <Tab
                      key={res.type_seq}
                      label={res.type_name}
                      {...a11yProps(res.type_seq)}
                    />
                  );
                })
              : ""}
          </Tabs>
        </AppBar>
        {internalUserList !== null && externalUserList !== null && (
          <TabPanel key={0} value={tabValue} index={0}>
            {getUserListLoading}

            {recipientType === "ARCHITECT" ||
            recipientType === "CONSULTANT" ||
            recipientType === "TOEXTERNAL" ? (
              <RFITransferList
                listData={externalUserList}
                userType="external"
                recipientType={recipientType}
                reciptentChipAdd={reciptentChipAdd}
                reciptentChipRemove={reciptentChipRemove}
                leftCcUserRcpt={leftCcUserRcpt}
                setLeftCcUserRcpt={setLeftCcUserRcpt}
                rightCcUserRcpt={rightCcUserRcpt}
                setRightCcUserRcpt={setRightCcUserRcpt}
                leftPMUserRcpt={leftPMUserRcpt}
                setLeftPMUserRcpt={setLeftPMUserRcpt}
                rightPMUserRcpt={rightPMUserRcpt}
                setRightPMUserRcpt={setRightPMUserRcpt}
                leftResponsibleUserRcpt={leftResponsibleUserRcpt}
                setLeftResponsibleUserRcpt={setLeftResponsibleUserRcpt}
                rightResponsibleUserRcpt={rightResponsibleUserRcpt}
                setRightResponsibleUserRcpt={setRightResponsibleUserRcpt}
                leftApproveUserRcpt={leftApproveUserRcpt}
                setLeftApproveUserRcpt={setLeftApproveUserRcpt}
                rightApproveUserRcpt={rightApproveUserRcpt}
                setRightApproveUserRcpt={setRightApproveUserRcpt}
                leftSecondApproveUserRcpt={leftSecondApproveUserRcpt}
                setLeftSecondApproveUserRcpt={setLeftSecondApproveUserRcpt}
                rightSecondApproveUserRcpt={rightSecondApproveUserRcpt}
                setRightSecondApproveUserRcpt={setRightSecondApproveUserRcpt}
                leftThirdApproveUserRcpt={leftThirdApproveUserRcpt}
                setLeftThirdApproveUserRcpt={setLeftThirdApproveUserRcpt}
                rightThirdApproveUserRcpt={rightThirdApproveUserRcpt}
                setRightThirdApproveUserRcpt={setRightThirdApproveUserRcpt}
                leftConsultantUserRcpt={leftConsultantUserRcpt}
                setLeftConsultantUserRcpt={setLeftConsultantUserRcpt}
                rightConsultantUserRcpt={rightConsultantUserRcpt}
                setRightConsultantUserRcpt={setRightConsultantUserRcpt}
                leftArchitectUserRcpt={leftArchitectUserRcpt}
                setLeftArchitectUserRcpt={setLeftArchitectUserRcpt}
                rightArchitectUserRcpt={rightArchitectUserRcpt}
                setRightArchitectUserRcpt={setRightArchitectUserRcpt}
                leftToUserRcpt={leftToUserRcpt}
                setLeftToUserRcpt={setLeftToUserRcpt}
                rightToUserRcpt={rightToUserRcpt}
                setRightToUserRcpt={setRightToUserRcpt}
                leftToExternalUserRcpt={leftToExternalUserRcpt}
                setLeftToExternalUserRcpt={setLeftToExternalUserRcpt}
                rightToExternalUserRcpt={rightToExternalUserRcpt}
                setRightToExternalUserRcpt={setRightToExternalUserRcpt}
              />
            ) : (
              <RFITransferList
                listData={internalUserList}
                userType="internal"
                recipientType={recipientType}
                reciptentChipAdd={reciptentChipAdd}
                reciptentChipRemove={reciptentChipRemove}
                leftCcUserRcpt={leftCcUserRcpt}
                setLeftCcUserRcpt={setLeftCcUserRcpt}
                rightCcUserRcpt={rightCcUserRcpt}
                setRightCcUserRcpt={setRightCcUserRcpt}
                leftPMUserRcpt={leftPMUserRcpt}
                setLeftPMUserRcpt={setLeftPMUserRcpt}
                rightPMUserRcpt={rightPMUserRcpt}
                setRightPMUserRcpt={setRightPMUserRcpt}
                leftResponsibleUserRcpt={leftResponsibleUserRcpt}
                setLeftResponsibleUserRcpt={setLeftResponsibleUserRcpt}
                rightResponsibleUserRcpt={rightResponsibleUserRcpt}
                setRightResponsibleUserRcpt={setRightResponsibleUserRcpt}
                leftApproveUserRcpt={leftApproveUserRcpt}
                setLeftApproveUserRcpt={setLeftApproveUserRcpt}
                rightApproveUserRcpt={rightApproveUserRcpt}
                setRightApproveUserRcpt={setRightApproveUserRcpt}
                leftSecondApproveUserRcpt={leftSecondApproveUserRcpt}
                setLeftSecondApproveUserRcpt={setLeftSecondApproveUserRcpt}
                rightSecondApproveUserRcpt={rightSecondApproveUserRcpt}
                setRightSecondApproveUserRcpt={setRightSecondApproveUserRcpt}
                leftThirdApproveUserRcpt={leftThirdApproveUserRcpt}
                setLeftThirdApproveUserRcpt={setLeftThirdApproveUserRcpt}
                rightThirdApproveUserRcpt={rightThirdApproveUserRcpt}
                setRightThirdApproveUserRcpt={setRightThirdApproveUserRcpt}
                leftConsultantUserRcpt={leftConsultantUserRcpt}
                setLeftConsultantUserRcpt={setLeftConsultantUserRcpt}
                rightConsultantUserRcpt={rightConsultantUserRcpt}
                setRightConsultantUserRcpt={setRightConsultantUserRcpt}
                leftArchitectUserRcpt={leftArchitectUserRcpt}
                setLeftArchitectUserRcpt={setLeftArchitectUserRcpt}
                rightArchitectUserRcpt={rightArchitectUserRcpt}
                setRightArchitectUserRcpt={setRightArchitectUserRcpt}
                leftToUserRcpt={leftToUserRcpt}
                setLeftToUserRcpt={setLeftToUserRcpt}
                rightToUserRcpt={rightToUserRcpt}
                setRightToUserRcpt={setRightToUserRcpt}
                leftToExternalUserRcpt={leftToExternalUserRcpt}
                setLeftToExternalUserRcpt={setLeftToExternalUserRcpt}
                rightToExternalUserRcpt={rightToExternalUserRcpt}
                setRightToExternalUserRcpt={setRightToExternalUserRcpt}
              />
            )}
          </TabPanel>
        )}
        {recipientType === "CC" && (
          <TabPanel key={1} value={tabValue} index={1}>
            {getUserListLoading}
            {externalUserList !== null ? (
              <RFITransferList
                listData={externalUserList}
                userType="external"
                recipientType={recipientType}
                reciptentChipAdd={reciptentChipAdd}
                reciptentChipRemove={reciptentChipRemove}
                leftCcUserRcpt={leftCcUserRcpt}
                setLeftCcUserRcpt={setLeftCcUserRcpt}
                rightCcUserRcpt={rightCcUserRcpt}
                setRightCcUserRcpt={setRightCcUserRcpt}
                leftPMUserRcpt={leftPMUserRcpt}
                setLeftPMUserRcpt={setLeftPMUserRcpt}
                rightPMUserRcpt={rightPMUserRcpt}
                setRightPMUserRcpt={setRightPMUserRcpt}
                leftResponsibleUserRcpt={leftResponsibleUserRcpt}
                setLeftResponsibleUserRcpt={setLeftResponsibleUserRcpt}
                rightResponsibleUserRcpt={rightResponsibleUserRcpt}
                setRightResponsibleUserRcpt={setRightResponsibleUserRcpt}
                leftApproveUserRcpt={leftApproveUserRcpt}
                setLeftApproveUserRcpt={setLeftApproveUserRcpt}
                rightApproveUserRcpt={rightApproveUserRcpt}
                setRightApproveUserRcpt={setRightApproveUserRcpt}
                leftSecondApproveUserRcpt={leftSecondApproveUserRcpt}
                setLeftSecondApproveUserRcpt={setLeftSecondApproveUserRcpt}
                rightSecondApproveUserRcpt={rightSecondApproveUserRcpt}
                setRightSecondApproveUserRcpt={setRightSecondApproveUserRcpt}
                leftThirdApproveUserRcpt={leftThirdApproveUserRcpt}
                setLeftThirdApproveUserRcpt={setLeftThirdApproveUserRcpt}
                rightThirdApproveUserRcpt={rightThirdApproveUserRcpt}
                setRightThirdApproveUserRcpt={setRightThirdApproveUserRcpt}
                leftConsultantUserRcpt={leftConsultantUserRcpt}
                setLeftConsultantUserRcpt={setLeftConsultantUserRcpt}
                rightConsultantUserRcpt={rightConsultantUserRcpt}
                setRightConsultantUserRcpt={setRightConsultantUserRcpt}
                leftArchitectUserRcpt={leftArchitectUserRcpt}
                setLeftArchitectUserRcpt={setLeftArchitectUserRcpt}
                rightArchitectUserRcpt={rightArchitectUserRcpt}
                setRightArchitectUserRcpt={setRightArchitectUserRcpt}
                leftToUserRcpt={leftToUserRcpt}
                setLeftToUserRcpt={setLeftToUserRcpt}
                rightToUserRcpt={rightToUserRcpt}
                setRightToUserRcpt={setRightToUserRcpt}
                leftToExternalUserRcpt={leftToExternalUserRcpt}
                setLeftToExternalUserRcpt={setLeftToExternalUserRcpt}
                rightToExternalUserRcpt={rightToExternalUserRcpt}
                setRightToExternalUserRcpt={setRightToExternalUserRcpt}
              />
            ) : (
              ""
            )}
          </TabPanel>
        )}

        {userGroupType !== null
          ? userGroupType.map((res, index) => {
              return (
                <TabPanel
                  key={index + idxCount}
                  value={tabValue}
                  index={index + idxCount}
                >
                  {getGroupListLoading}
                  {userGroupList !== null ? (
                    <RFITransferGroupList
                      typeSeq={res.type_seq}
                      internalOnly={internalOnly}
                      listData={userGroupList}
                      recipientType={recipientType}
                      reciptentChipAdd={reciptentChipAdd}
                      reciptentChipRemove={reciptentChipRemove}
                      leftCcGroupRcpt={leftCcGroupRcpt}
                      setLeftCcGroupRcpt={setLeftCcGroupRcpt}
                      rightCcGroupRcpt={rightCcGroupRcpt}
                      setRightCcGroupRcpt={setRightCcGroupRcpt}
                      leftPMGroupRcpt={leftPMGroupRcpt}
                      setLeftPMGroupRcpt={setLeftPMGroupRcpt}
                      rightPMGroupRcpt={rightPMGroupRcpt}
                      setRightPMGroupRcpt={setRightPMGroupRcpt}
                      leftResponsibleGroupRcpt={leftResponsibleGroupRcpt}
                      setLeftResponsibleGroupRcpt={setLeftResponsibleGroupRcpt}
                      rightResponsibleGroupRcpt={rightResponsibleGroupRcpt}
                      setRightResponsibleGroupRcpt={
                        setRightResponsibleGroupRcpt
                      }
                      leftApproveGroupRcpt={leftApproveGroupRcpt}
                      setLeftApproveGroupRcpt={setLeftApproveGroupRcpt}
                      rightApproveGroupRcpt={rightApproveGroupRcpt}
                      setRightApproveGroupRcpt={setRightApproveGroupRcpt}
                      leftSecondApproveGroupRcpt={leftSecondApproveGroupRcpt}
                      setLeftSecondApproveGroupRcpt={
                        setLeftSecondApproveGroupRcpt
                      }
                      rightSecondApproveGroupRcpt={rightSecondApproveGroupRcpt}
                      setRightSecondApproveGroupRcpt={
                        setRightSecondApproveGroupRcpt
                      }
                      leftThirdApproveGroupRcpt={leftThirdApproveGroupRcpt}
                      setLeftThirdApproveGroupRcpt={
                        setLeftThirdApproveGroupRcpt
                      }
                      rightThirdApproveGroupRcpt={rightThirdApproveGroupRcpt}
                      setRightThirdApproveGroupRcpt={
                        setRightThirdApproveGroupRcpt
                      }
                      leftConsultantGroupRcpt={leftConsultantGroupRcpt}
                      setLeftConsultantGroupRcpt={setLeftConsultantGroupRcpt}
                      rightConsultantGroupRcpt={rightConsultantGroupRcpt}
                      setRightConsultantGroupRcpt={setRightConsultantGroupRcpt}
                      leftArchitectGroupRcpt={leftArchitectGroupRcpt}
                      setLeftArchitectGroupRcpt={setLeftArchitectGroupRcpt}
                      rightArchitectGroupRcpt={rightArchitectGroupRcpt}
                      setRightArchitectGroupRcpt={setRightArchitectGroupRcpt}
                      leftToGroupRcpt={leftToGroupRcpt}
                      setLeftToGroupRcpt={setLeftToGroupRcpt}
                      rightToGroupRcpt={rightToGroupRcpt}
                      setRightToGroupRcpt={setRightToGroupRcpt}
                      leftToExternalGroupRcpt={leftToExternalGroupRcpt}
                      setLeftToExternalGroupRcpt={setLeftToExternalGroupRcpt}
                      rightToExternalGroupRcpt={rightToExternalGroupRcpt}
                      setRightToExternalGroupRcpt={setRightToExternalGroupRcpt}
                    />
                  ) : (
                    ""
                  )}
                </TabPanel>
              );
            })
          : ""}
      </div>
    </Fragment>
  );
};

export default RFIRecipientForm;
